// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3-myi","footer":"Form_footer__OzKsp"};